import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DetailOperations, Operations } from '../../../interface/company-client.interface';
import { ServiceInfoClientService } from '../../../service/service-info-client.service';
import { DetalleFactVComponent } from '../detalle-fact-v/detalle-fact-v.component';

@Component({
  selector: 'app-detalle-operations',
  templateUrl: './detalle-operations.component.html',
  styleUrls: ['./detalle-operations.component.scss']
})
export class DetalleOperationsComponent {

  public detailOperations: DetailOperations;
  public datosCargados: boolean;

  constructor(@Inject(MAT_DIALOG_DATA) public data: Operations, private serviceInfo: ServiceInfoClientService, public dialogRef: MatDialogRef<DetalleFactVComponent>) {
    this.datosCargados = false;
  }

  ngOnInit() {
    this.obtenerDetalleOperacion();
  }

  obtenerDetalleOperacion() {
    this.serviceInfo.getDetailOperations(this.data.invoiceOperationId).subscribe( (result) => {
      this.detailOperations = result;
      console.log("Detalle Operacion: ");
      console.log(this.detailOperations);
      this.datosCargados = true;
    });
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

}
